// extracted by mini-css-extract-plugin
module.exports = {"form":"Register_form__gC_vE","policy":"Register_policy__py7y0"};